import { Section } from 'components/Section';
import { Cell, Grid } from 'components/Grid';
import { Ad } from 'components/Ad';
import { AdBlock } from 'models/AdBlock';
import { NO_ELEMENT } from 'utils';

export const Ads = ({ ad, ads, ...props }: AdBlock) => {
  let content;
  if (ad) {
    content = <Ad ad={ad} />;
  } else if (ads) {
    content = (
      <Grid tablet="2" phone="1" gutters="extraLarge">
        {ads.map((item, i) => (
          <Cell key={item.url}>
            <Ad ad={item} position={i} />
          </Cell>
        ))}
      </Grid>
    );
  } else {
    return NO_ELEMENT;
  }
  return <Section {...props}>{content}</Section>;
};
